<template>
  <section>
    <SharedPageHeaderTitle :title="t('pages.features.chats.headerTitle')" />

    <div class="base-container-first chat__wrapper">
      <ul class="chat__cards">
        <li
          v-for="(card, cardIndex) in CARDS"
          :key="cardIndex"
        >
          <SharedPageCard
            isWhite
            :card
          />
        </li>
      </ul>

      <SharedPageBusiness :business-list="BUSINESSES" />

      <ul class="chat__cards">
        <li
          v-for="(advantage, advantageIndex) in ADVANTAGES"
          :key="advantageIndex"
        >
          <SharedPageCard
            isWhite
            :card="advantage"
          />
        </li>
      </ul>
    </div>
  </section>

  <ContactOrderForm
    :description="t('pages.features.chats.managerDescription')"
    :title="t('pages.features.chats.questionsTitle')"
  />
</template>

<script setup lang="ts">
const { t, locale } = useI18n();

const CARDS = computed(() => [
  {
    description: t("pages.features.chats.cards.chatsCrm.description"),
    image: "chat-card-1",
    title: t("pages.features.chats.cards.chatsCrm.title"),
  },
  {
    description: t("pages.features.chats.cards.messengers.description"),
    image: "chat-card-2",
    title: t("pages.features.chats.cards.messengers.title"),
  },
]);

const BUSINESSES = computed(() => [
  t("pages.features.chats.businesses.beautySalon"),
  t("pages.features.chats.businesses.clothingStore"),
  t("pages.features.chats.businesses.lawyer"),
  t("pages.features.chats.businesses.barbershop"),
  t("pages.features.chats.businesses.carWash"),
  t("pages.features.chats.businesses.fitness"),
  t("pages.features.chats.businesses.notary"),
  t("pages.features.chats.businesses.photoStudio"),
  t("pages.features.chats.businesses.billiardRoom"),
  t("pages.features.chats.businesses.yourBusiness"),
]);

const ADVANTAGES = computed(() => [
  {
    description: t("pages.features.chats.cards.quickActions.description"),
    image: "chat-card-3",
    title: t("pages.features.chats.cards.quickActions.title"),
  },
  {
    description: t("pages.features.chats.cards.automation.description"),
    image: "chat-card-4",
    title: t("pages.features.chats.cards.automation.title"),
  },
]);

useSeoMeta({
  title: t("pages.features.chats.seo.title"),
});
</script>

<style scoped>
.chat__wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 80px;
  margin: 0 auto 80px;
  padding: 0 24px;
}

@media (--desktop) {
  .chat__wrapper {
    row-gap: 120px;
    margin-bottom: 120px;
  }
}

.chat__cards {
  display: grid;
  row-gap: 16px;
}

@media (--desktop) {
  .chat__cards {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 20px;
  }
}
</style>
